import { useEffect, useRef } from 'react';

/**
 * Spec 0216 §5.2 (Plan §0.2 Option B):
 *
 * Da das Repo `<BrowserRouter>` nutzt (kein `createBrowserRouter`), ist
 * `useBlocker` aus React Router v6 nicht verfuegbar. Dieser Hook ist die
 * minimale Browser-seitige Schutzschicht: wenn `isDirty=true` und der User
 * versucht den Tab zu schliessen, neu zu laden oder zu einer anderen Seite
 * zu wechseln, zeigt der Browser den generischen "Aenderungen verwerfen?"-
 * Dialog (Chrome/Firefox zeigen seit 2016 keinen Custom-Text mehr).
 *
 * Fuer in-App-Navigation reicht das nicht; der zugehoerige `GuardedLink`-
 * Wrapper faengt React-Router-Klicks ab und triggert einen App-internen
 * Confirm-Dialog (siehe `discard-confirmation.tsx`).
 */
export function useUnsavedChangesPrompt(isDirty: boolean): void {
  const dirtyRef = useRef(isDirty);
  dirtyRef.current = isDirty;

  useEffect(() => {
    const handler = (event: BeforeUnloadEvent) => {
      if (!dirtyRef.current) return;
      event.preventDefault();
      // Chrome braucht ein gesetztes returnValue, Firefox akzeptiert auch
      // einen leeren String. Der Text wird seit ca. 2016 ignoriert.
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, []);
}
